const yesNoEnum = [
  { label: 'Ja', value: true },
  { label: 'Nein', value: false }
]

export default yesNoEnum
